import mixin from '@/store/mixins/data-grid'

const { stateMixin, gettersMixin, mutationsMixin, actionsMixin } = mixin

const state = {
  ...stateMixin('product', 'created_at'),

  taxType: 'sales'
}

const getters = {
  ...gettersMixin(),

  taxType: (state) => state.taxType
}

const mutations = {
  ...mutationsMixin(),

  setTaxType (state, type) {
    state.taxType = type
  }
}

const actions = {
  ...actionsMixin({ include: ['images', 'categories', 'taxonomy'] }),

  async fetchTaxSettings ({ commit }) {
    const taxSettings = await this._vm.$http.make('settings').find('general/taxes')
    commit('setTaxType', taxSettings.type)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
